import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import media from 'src/styles/Media.styled';

export const StyledCarousel = styled(Carousel)`
    & .carousel:not(.carousel-slider) {
        display: none;
    }

    & .carousel-slider {
        height: auto;
        overflow: unset !important;
        & .control-arrow,
        & .carousel-status {
            display: none;
        }
            border: 1px solid transparent !important;
        & .control-dots {
            margin: ${({ marginControlDots }) =>
                marginControlDots ? marginControlDots : '10px 0 10px 0'};
            bottom: ${({ setBottom }) =>
                setBottom === '-35px'
                    ? setBottom
                    : setBottom
                    ? '25px'
                    : '-25px'};
            // padding-right: 30px;
            white-space: nowrap; /* Ensure dots stay in a single line */
            overflow-x: auto; /* Allow horizontal scrolling for dots on mobile */
            left:  50%;
            transform: translate(-50%);
            & .dot {
                margin: 0 2.5px 0 2.5px;
                box-shadow: none;
                width: 6px;
                height: 6px;
                display: inline-block; /* Display dots in a single line */
            }
            & .dot:not(.selected) {
                background-color: #9a9a9a !important;
                box-shadow: none;
            }
            & .dot.selected {
                background-color: #1010eb !important;
                border: 1px solid #1010eb !important;
                opacity: 1;
            }
            ${media.mobileDevice`
                bottom: ${({ mobileBottom }) => mobileBottom && mobileBottom };
            `}
        }
        & .slider-wrapper {
            margin: unset;
            width: 100%;
            overflow: unset !important;
            ${media.mobileDevice`
                margin-bottom: 40px;
            `}
            & .slider {
                width: 317px;
                & .slide {
                    /* margin: 0 14px 0 0; */
                    min-width: ${({ minWidth }) =>
                        minWidth ? minWidth : '98%'};
                    margin-right: ${({ marginRight }) =>
                        marginRight ? marginRight : '8px'};
                    //height: 120px;
                }
            }
            & .slider.animated {
                transition: all 0s -1.65s ease-in-out;
            }
        }
    }
`;
